<template>
  <tooltip v-if="hasPermission(permission)" label="Cancel" type="small" placement="top">
    <button type="button" @click="onClick" class="button is-danger">
      <span class="icon">
        <i class="fa fa-ban"></i>
      </span>
    </button>
  </tooltip>
</template>

<script>
    import mixin from 'components/mixin';

    export default {
        mixins: [mixin],
        name: "cancel-button",
        props: {
            permission: Array
        },
        methods: {
            onClick() {
                this.$emit('click');
            }
        }
    }
</script>

<style scoped>

</style>